import { Box, Text } from "@chakra-ui/react";

const TrialLabel = ({ label, fontSize = "xxs", fontWeight = "normal", withBorder = true }) => {
  const gradientPosition = withBorder ? "90deg" : "270deg";
  return (
    <Box
      paddingY={fontSize !== "lg" ? "1" : "2"}
      paddingX={fontSize !== "lg" ? "2" : "4"}
      borderColor="trialBlackBorder"
      borderWidth={withBorder ? "1px" : undefined}
      borderRadius="3xl"
      width="fit-content"
      bgGradient={`linear(${gradientPosition}, gold 11.7%, yellow 100%)`}
    >
      <Text fontWeight={fontWeight} fontSize={fontSize} color="trialBlack">
        {label ?? "-"}
      </Text>
    </Box>
  );
};

export default TrialLabel;
